/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_TitleInputs */

const en_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Marker Thumbnails?`)
};

const fr_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer des vignettes de marqueurs ?`)
};

const de_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker-Miniaturansichten generieren?`)
};

const it_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generare miniature dei marcatori?`)
};

const ru_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать миниатюры-маркеры?`)
};

const es_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Generar miniaturas de marcadores?`)
};

const zh_cn2_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成标记缩略图？`)
};

const ja_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーのサムネイルを生成しますか？`)
};

const hi_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर थंबनेल कैसे जनरेट करें?`)
};

const pt_pt2_scene_change_detection_thumbnail_prompt_title = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar miniaturas de marcadores?`)
};

/**
* | output |
* | --- |
* | "Generate Marker Thumbnails?" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_title = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "de") return de_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "it") return it_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "ru") return ru_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "es") return es_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "ja") return ja_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "hi") return hi_scene_change_detection_thumbnail_prompt_title(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_thumbnail_prompt_title(inputs)
	return en_scene_change_detection_thumbnail_prompt_title(inputs)
});